import PropTypes from 'prop-types'

const componentPropType = PropTypes.oneOfType([
  PropTypes.func,
  PropTypes.node,
  PropTypes.object
])

export default componentPropType
